export { isBrowser } from "./is-browser";
